var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFileSystem({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "files_svgrepo.com"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10 4.75L10.5304 4.21962C10.4607 4.14998 10.378 4.09474 10.287 4.05706C10.196 4.01938 10.0985 3.99999 10 4V4.75ZM12 6.75L11.4696 7.28037C11.5393 7.35002 11.622 7.40526 11.713 7.44294C11.804 7.48062 11.9015 7.50001 12 7.5V6.75ZM19.25 18.5H4.75V20H19.25V18.5ZM3.5 17.25V6.75H2V17.25H3.5ZM4.75 5.5H10V4H4.75V5.5ZM9.46963 5.28037L11.4696 7.28037L12.5304 6.21962L10.5304 4.21962L9.46963 5.28037ZM20.5 8.75V17.25H22V8.75H20.5ZM12 7.5H19.25V6H12V7.5ZM4.75 18.5C4.05963 18.5 3.5 17.9404 3.5 17.25H2C2 18.7687 3.23125 20 4.75 20V18.5ZM19.25 20C20.7687 20 22 18.7687 22 17.25H20.5C20.5 17.9404 19.9404 18.5 19.25 18.5V20ZM22 8.75C22 7.23125 20.7687 6 19.25 6V7.5C19.9404 7.5 20.5 8.05962 20.5 8.75H22ZM3.5 6.75C3.5 6.05962 4.05963 5.5 4.75 5.5V4C3.23125 4 2 5.23125 2 6.75H3.5Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileSystem);
export default __webpack_public_path__ + "static/media/FileSystem.2a33a01baeb7f99f636c2a969e79cc48.svg";
export { ForwardRef as ReactComponent };